import { ImageViewerLocal } from "@/components/ImageViewerLocal";
import { safeRealName } from "@/utils/safe";
import classNames from "classnames";
import styles from "./styles.module.scss";
type AlipayInfo = {
  receiptCode: string;
  province: string;
  city: string;
  alipayAccount: string;
  realName: string;
};
type AlipayItemProps = {
  item: AlipayInfo;
  index: number;
};

export const AlipayItem = ({ item, index }: AlipayItemProps) => {
  return (
    <div className={classNames(styles.card)}>
      <div className={styles.item_icon}></div>

      <div className={styles.item_text}>
        <div>支付宝账号：{item.alipayAccount}</div>
        <div>姓名：{safeRealName(item.realName)}</div>
      </div>
      <div className={styles.item_code}>
        <ImageViewerLocal src={item.receiptCode} directive />
      </div>
    </div>
  );
};
